<template>
    <div v-if="authStore.hasUserPermission('customerservice.view')" class="card">
      <Panel header="Header" :toggleable="true">
        <template #header>
          <h1 class="m-0">Anleitung (Kundenservice)</h1>
        </template>
        <div class="reklamation-container">
            <div class="reklamation-section">
        <p class="m-0">
        <h3>Reklamation erstellen:</h3>
        <p>
            1. Klicke ganz oben links auf: 
            <br><Button style="margin-top: 1rem"outlined text label="Eintrag Erstellen"severity="success" icon="fa-solid fa-plus"></Button></p>
        </p>
        <p>2. Trage die Daten ein:
            <Panel  style="width: 25rem;">
                <template #header>
                    <h5 class="m-0">Beispiel-Eintrag</h5>
                </template>
                <FloatLabel>
  <AutoComplete
    id="createdby"
    v-model="createdby"
    :suggestions="createdbySuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    optionLabel="name"
    dropdown
  />
  <label for="article">Ersteller</label>
</FloatLabel>
<h5>Wer hat diese Reklamation eingetragen oder erstellt (der Vorname reicht, z.B Lee, Mike, etc..)</h5>
      <FloatLabel>
  <Calendar id="date" v-model="date" dateFormat="dd.mm.yy" showIcon class="cua-modal-btn" />
  <label for="date">Auftrittsdatum</label>
</FloatLabel>
<h5>Wann ist der Fehler aufgefallen, Wann wurde die Reklamation geschrieben?</h5>
<FloatLabel>
  <AutoComplete
    id="supplier"
    v-model="supplier"
    :suggestions="supplierSuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="supplier">Lieferant</label>
</FloatLabel>
<h5>Welcher Lieferant hat den Artikel / die Artikel die Reklamiert werden müssen geliefert?</h5>
      <FloatLabel>
        <InputText id="order" type="number" v-model="order" class="cua-modal-btn"></InputText>
        <label for="order">Bestellnummer</label>
      </FloatLabel>
      <h5>Die Bestellnummer des Kunden</h5>
      <FloatLabel>
  <AutoComplete
    id="article"
    v-model="article"
    :suggestions="articleSuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="article">Artikelnummer</label>
</FloatLabel>
<h5>Der Reklamierte Artikel</h5>
      <FloatLabel>
        <Dropdown id="reason" v-model="reason" :options="reasonOptions" class="cua-modal-btn"></Dropdown>
        <label for="reason">Reklamationsgrund</label>
      </FloatLabel>
      <h5>Warum wird der Artikel reklamiert? <br>z.B Mengendifferenz = Es wurde mehr / Weniger geliefert als auf dem Lieferschein steht</h5>
      <FloatLabel>
        <InputText id="should" type="text" v-model="should" class="cua-modal-btn"></InputText>
        <label for="should">SOLL-Menge</label>
      </FloatLabel>
      <h5>Wieviel von Diesem Artikel sollte geliefert werden (Lieferschein kontrollieren, Lieferantenbestellung kontrollieren)</h5>
      <FloatLabel>
        <InputText id="is" type="text" v-model="is" class="cua-modal-btn"></InputText>
        <label for="is">IST-Menge</label>
      </FloatLabel>
      <h5>Wieviel ist wirklich bei uns Angekommen.</h5>
      <FloatLabel>
        <InputText id="comment" type="text" v-model="comment" class="cua-modal-btn"></InputText>
        <label for="comment">Kommentar</label>
      </FloatLabel>
      <h5>Falls zusätliche Informationen angegeben werden müssen</h5>
      <Divider></Divider>
      <h3>Alles sorgfältig noch einmal überprüfen, und Dann Bestätigen mit "Eintrag speichern"</h3>
      <Button class="cua-modal-btn" icon="fa-solid fa-check"
        severity="success" label="Eintrag speichern"></Button>
            </Panel>
        </p>
        </div>

        <div class="reklamation-section">
        <p class="m-0">
        <h3>Reklamation bearbeiten:</h3>
        <p>
            1. Klicke den Eintrag an, den du bearbeiten möchtest: 
        </p>
        </p>
        <p style="margin-top:4rem;"></p>
        <p>2. Ändere die Daten, die du ändern möchtest:
            <Panel style="width: 25rem;">
                <template #header>
                    <h5 class="m-0">Beispiel-Eintrag</h5>
                </template>
                <FloatLabel>
  <AutoComplete
    id="createdby"
    v-model="createdby"
    :suggestions="createdbySuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    optionLabel="name"
    dropdown
  />
  <label for="article">Ersteller</label>
</FloatLabel>
<h5>Wer hat diese Reklamation eingetragen oder erstellt (der Vorname reicht, z.B Lee, Mike, etc..)</h5>
      <FloatLabel>
  <Calendar id="date" v-model="date" dateFormat="dd.mm.yy" showIcon class="cua-modal-btn" />
  <label for="date">Auftrittsdatum</label>
</FloatLabel>
<h5>Wann ist der Fehler aufgefallen, Wann wurde die Reklamation geschrieben?</h5>
<FloatLabel>
  <AutoComplete
    id="supplier"
    v-model="supplier"
    :suggestions="supplierSuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="supplier">Lieferant</label>
</FloatLabel>
<h5>Welcher Lieferant hat den Artikel / die Artikel die Reklamiert werden müssen geliefert?</h5>
      <FloatLabel>
        <InputText id="order" type="number" v-model="order" class="cua-modal-btn"></InputText>
        <label for="order">Bestellnummer</label>
      </FloatLabel>
      <h5>Die Bestellnummer des Kunden</h5>
      <FloatLabel>
  <AutoComplete
    id="article"
    v-model="article"
    :suggestions="articleSuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="article">Artikelnummer</label>
</FloatLabel>
<h5>Der Reklamierte Artikel</h5>
      <FloatLabel>
        <Dropdown id="reason" v-model="reason" :options="reasonOptions" class="cua-modal-btn"></Dropdown>
        <label for="reason">Reklamationsgrund</label>
      </FloatLabel>
      <h5>Warum wird der Artikel reklamiert? <br>z.B Mengendifferenz = Es wurde mehr / Weniger geliefert als auf dem Lieferschein steht</h5>
      <FloatLabel>
        <InputText id="should" type="text" v-model="should" class="cua-modal-btn"></InputText>
        <label for="should">SOLL-Menge</label>
      </FloatLabel>
      <h5>Wieviel von Diesem Artikel sollte geliefert werden (Lieferschein kontrollieren, Lieferantenbestellung kontrollieren)</h5>
      <FloatLabel>
        <InputText id="is" type="text" v-model="is" class="cua-modal-btn"></InputText>
        <label for="is">IST-Menge</label>
      </FloatLabel>
      <h5>Wieviel ist wirklich bei uns Angekommen.</h5>
      <FloatLabel>
        <InputText id="comment" type="text" v-model="comment" class="cua-modal-btn"></InputText>
        <label for="comment">Kommentar</label>
      </FloatLabel>
      <h5>Falls zusätliche Informationen angegeben werden müssen</h5>
      <FloatLabel>
  <Dropdown id="reklaausgang" v-model="reklaausgang" :options="reklaausgangOptions" class="cua-modal-btn"></Dropdown>
  <label for="reklaausgang">Rekla-Ausgang</label>
</FloatLabel>
<h5>Hier würde angegeben werden, was mit den Artikeln nun Passiert ist.</h5>


<FloatLabel>
  <Dropdown id="accounting_action" v-model="accounting_action" :options="accounting_actionOptions" class="cua-modal-btn"></Dropdown>
  <label for="accounting_action">Buchhaltung</label>
</FloatLabel>
<h5>Falls Buchhaltung oder "Andere -> Kommentar" im Reklaausgang ausgewählt wurde, Kann man eine Buchhaltungsaktion auswählen, falls diese Passiert ist.</h5>

<FileUpload
  name="file"
  :auto="true"
  :customUpload="false"
  accept="application/pdf"
  :maxFileSize="5000000"
>
  <template #empty>
    <span>Gutschrift/Rechnung (als PDF) Hier hinziehen.</span>
  </template>
</FileUpload>
<h5>Falls Die Buchhaltungsaktion ausgewählt wurde, erscheint dieses Fenster, hier Kann man Gutschriften oder Rechnungen hochladen die wir Für Artikel, die Wir behalten oder Zurückgesendet haben hochladen, somit hat die Buchhaltung eine Gute Übersicht über alles <br><br> Drücke "Choose" um Eine Datei auf deinem Computer auszuwählen</h5>
<Panel
  header="Anhang"
  class="mt-4"
>
  <p>
    <a
    href=#
      
      style="color: #42a5f5; text-decoration: underline;"
    >
      Anhang anzeigen (PDF öffnen)
    </a>
    <br>
    (Beispiel, hat kein Anhang. aber so könnte es aussehen)
  </p>
</Panel>
<h5>Falls ein Anhang (eine Gutschrift oder eine Rechnung) existiert, so kann dieser hier eingesehen werden</h5>


      <Divider></Divider>
      <h3>Alles sorgfältig noch einmal überprüfen, und Dann Bestätigen mit "Eintrag speichern"</h3>
      <Button class="cua-modal-btn" icon="fa-solid fa-check"
        severity="success" label="Eintrag speichern"></Button>
            </Panel>
        </p>
        </div>
        <div class="reklamation-section">
        <p class="m-0">
        <h3>Reklamation Löschen:</h3>
        <p>
            1. Klicke den Eintrag an, den du löschen möchtest: 
        </p>
        </p>
        <p style="margin-top:4rem;"></p>
        <p>Gehe Nach ganz unten
            <Panel style="width: 25rem;">
                <template #header>
                    <h5 class="m-0">Beispiel-Eintrag</h5>
                </template>
                <FloatLabel>
  <AutoComplete
    id="createdby"
    v-model="createdby"
    :suggestions="createdbySuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    optionLabel="name"
    dropdown
  />
  <label for="article">Ersteller</label>
</FloatLabel>
<h5>Wer hat diese Reklamation eingetragen oder erstellt (der Vorname reicht, z.B Lee, Mike, etc..)</h5>
      <FloatLabel>
  <Calendar id="date" v-model="date" dateFormat="dd.mm.yy" showIcon class="cua-modal-btn" />
  <label for="date">Auftrittsdatum</label>
</FloatLabel>
<h5>Wann ist der Fehler aufgefallen, Wann wurde die Reklamation geschrieben?</h5>
<FloatLabel>
  <AutoComplete
    id="supplier"
    v-model="supplier"
    :suggestions="supplierSuggestions"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="supplier">Lieferant</label>
</FloatLabel>
<h5>(Gekürzt)</h5>
      <Divider></Divider>
      <h3>Wenn es ganz sicher ist, dass der Eintrag gelöscht werden soll, So klicke "Eintrag löschen"</h3>
      <Button  class="cua-modal-btn" on="fa-solid fa-cancel" severity="danger" text
      outlined label="Löschen"></Button>
            </Panel>
        </p>
        </div>
        <div class="reklamation-section">
        <p class="m-0">
        <h3>Reklamation Teilen:</h3>
        <p>
            1. Klicke den Eintrag 2 mal Schnell hintereinander an, um eine Auswahl zu erhalten, als Welche Abteilung du den Eintrag teilen möchtest:
            <br>
            <br><strong>Beispiel:</strong><br>
            <img src="@/assets/contextmenu.png">
            <br>
        </p>
        </p>
        <p style="margin-top:2rem;"></p>
        <p>Nun, kannst du ganz einfach in z.B Microsoft Teams. Rechtsklick -> Einfügen Klicken, und der Eintrag wird als Link eingefügt, und die Person die den Eintrag erhält, kann ihn direkt öffnen.

        </p>
        </div>
        </div>




      </Panel>
    </div>
  </template>
  
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import axios from "axios";
  import { getAuth } from "firebase/auth";
  import { config } from "@/assets/config.js";
  import { useAuthStore } from "@/stores/auth.js";
  import { useRoute, useRouter } from 'vue-router';
  import Panel from "primevue/panel";
import Button from "primevue/button";
import FloatLabel from "primevue/floatlabel";
import AutoComplete from "primevue/autocomplete";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Calendar from 'primevue/calendar';
import Divider from "primevue/divider";
import FileUpload from "primevue/fileupload";
import ContextMenu from "primevue/contextmenu";
  
  export default {
    components: {
      Panel,
      Button,
      FloatLabel,
      AutoComplete,
      InputText,
      Dropdown,
      Calendar,
      Divider,
      FileUpload,
      ContextMenu
    },
  
    data() {
    return {
      authStore: useAuthStore(),
      warehousereclamationsearch: [],
      supplierSuggestions: [],
      articleSuggestions: [],
      createdbySuggestions: [],
      filters: {
        supplier: { value: "", matchMode: FilterMatchMode.CONTAINS },
        order: { value: "", matchMode: FilterMatchMode.CONTAINS },
        incomegoodsnumber: { value: "", matchMode: FilterMatchMode.CONTAINS },
        article: { value: "", matchMode: FilterMatchMode.CONTAINS },
      },
      uploadToken: null,
      loading: true,
      dialogOpen: false,
      size: "small",
      createdby: null,
      date: null,
      configURL: config.api_url,
      supplier: null,
      order: null,
      incomegoodsnumber: null,
      article: null,
      reason: null,
      attachment: null,
      should: null,
      is: null,
      comment: null,
      displayName: null,
      selectedEntry: null,
      completeddate: null,
      reklaausgang: null,
      accounting_action: null,
      showaccounting_actionDropdown: false,
      reklaausgangOptions: [
        "Zurückgeschickt",
        "Outlet",
        "Eingelagert",
        "Nachgeliefert",
        "Ersatzlieferung",
        "Keine Antwort -> Kommentar",
        "Andere... -> Kommentar",
        "Buchhaltung"
      ],
      reasonOptions: [
        "Mengendifferenz",
        "Beschädigt",
        "Nicht geliefert",
        "Falsch geliefert",
        "Qualitätsdifferenz",
        "Backorderüberschreitung",
        "Andere... -> Kommentar",
      ],
      accounting_actionOptions: ["Rechnung", "Gutschrift"],
      contextMenuItems: [],
contextEntry: null,
claimFilterId: null,
    };
  },
  };
  </script>
  
  
  
  <style lang="scss" scoped>
  /* 🔹 Standard Button & Input Styles */
.cua-modal-btn {
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 0.5rem;
}
.reklamation-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap; /* Optional: allow wrapping on smaller screens */
}

.reklamation-section {
  flex: 1 1 45%;
  min-width: 300px;
}

  </style>
  